module.exports = __webpack_public_path__ + "static/media/wide_button.7c2f8288.png";